import { observable, action, makeObservable, computed } from "mobx";

import { chatChannels } from "../../consts";

class FeedNotification {
  constructor(rootStore, data) {
    makeObservable(this, {
      isVisible: observable,
      isClose: observable,
      groupedMessages: observable,
      hide: action,
      close: action,
      disableNtf: action,
      addGroupedChatMessage: action,
      groupedChatMessagesCounter: computed,
    });

    this.rootStore = rootStore;

    this.id = data.id || data.ID;

    this.ntfType = data.type || data.Type;
    this.ntfMessage = data.message || data.Message;
    this.ntfFeedMessage = data.feed_msg || data.FeedMsg;
    this.ntfAction = data.feed_action_url || data.FeedActionUrl;
    this.feedType = data.feed_type || data.FeedType;
    this.customId = data.custom_id || data.CustomID;
    this.tag = data.tag || data.Tag;
    this.senderFirmId = data.sender_firm_id || data.SenderFirmId;
    this.deliveryId = data.delivery_id || data.DeliveryId;

    this.isImportant = this.feedType === 1;

    // Параметры нотификаций из чата
    this.isChat = data.IsChat;
    this.isGroup = data.chat && data.chat.channel_type === "group";
    this.isChannel =
      data.chat &&
      (data.chat.channel_type === "channel" ||
        data.chat.channel_type === "ati_driver");
    this.channelId = data.channelId;
    if (this.isGroup || this.isChannel) this.chatName = data.chat.name;

    this.channelId = data.channel;
    this.user = data.user;
    this.message = data.text;
    this.sender = data.from;

    this.imageId = data.image_id;
    this.imageLink = `https://chat.${this.rootStore.baseUrl}/api/1.2/messages/${data.message.id}/image`;
    this.imageName = data.image_name;

    console.log("data", data);

    this.fileId = data.file_id;
    this.fileName = data.file_name;
    this.fileSize = data.file_size;

    this.document = data.document;

    if (
      data.channelName === chatChannels.GROUP_INVITE ||
      data.channelName === chatChannels.GROUP_EXCLUDE
    ) {
      this.isGroup = true;
      this.sender = data.name;
    }

    if (data.channelName === chatChannels.GROUP_INVITE) {
      this.channelId = data.tail?.channel || data.groupId;
      this.message = `Вас пригласили в ${
        data.channel_type === "group" ? "группу" : "канал"
      } ${data.name}`;
    }

    if (data.channelName === chatChannels.GROUP_EXCLUDE) {
      this.channelId = null;
      this.message = `Вы удалены из ${
        data.channel_type === "group" ? "группы" : "канала"
      } ${data.name}`;
    }

    if (this.user) {
      [this.chatSenderFirmId, this.chatSenderContactId] = this.user.split(".");
    }

    if (this.message && this.message.indexOf("от") !== -1) {
      this.documentType = this.message.split("от")[0].trim();
      this.documentDate = `от ${this.message.split("от")[1].trim()}`;
    }

    this.prettyFileSize = this.getPrettyFileSize();
    this.chatMessageType = this.getChatMessageType();
    this.messageLink = this.getMessageLink();
    this.ntfText = this.getNtfText();
    this.avatar = this.getAvatar();
  }

  isVisible = true;

  isClose = false;

  channelId = null;

  /** Сообщения, которые сгруппированы вместе с текущим */
  groupedMessages = new Set();

  /** Текущее сообщение было показано в рамках сгруппированного сообщения */
  wasShownAsGroupedMessageMember = false;

  getChatMessageType = () => {
    if (this.imageId) return "image";
    if (this.fileId) return "file";
    if (this.document) return "document";

    return "text";
  };

  getAvatar = () => {
    const { chatUrl, apiUrl } = this.rootStore.feedSettings;
    let url = "";

    if (this.fileId || this.document) {
      url = this.fileId
        ? `${chatUrl}/assets/img/file.svg`
        : `${chatUrl}/assets/img/document.svg`;
    } else {
      url = this.chatSenderFirmId?.includes("driver")
        ? `https://${this.rootStore.baseUrl}/gw/plyushkin/public/v1/avatar/default`
        : `${apiUrl}/avatars/${this.chatSenderFirmId}/contacts/${this.chatSenderContactId}`;
    }

    return url;
  };

  getMessageLink() {
    if (this.isGroup || this.isChannel) {
      if (this.channelId) {
        return `${this.rootStore.feedSettings.chatUrl}/#${this.channelId}`;
      }
      return `${this.rootStore.feedSettings.chatUrl}`;
    }
    return `${this.rootStore.feedSettings.chatUrl}/dialogs/${this.user}?from=widget`;
  }

  getPrettyFileSize = () => {
    if (!this.fileSize) return null;

    const sizeBytes = this.fileSize;
    let sOutput = `${sizeBytes.toString()} байт`;

    for (
      let aMultiples = ["Кб", "Мб"], nMultiple = 0, sBytes = sizeBytes / 1024;
      sBytes > 1;
      sBytes /= 1024, nMultiple++
    ) {
      sOutput = `${sBytes.toFixed()} ${aMultiples[nMultiple]}`;
    }

    return sOutput;
  };

  getNtfText = () => {
    if (this.message) return this.message;

    if (this.ntfFeedMessage) {
      return this.ntfFeedMessage;
    }

    if (typeof this.ntfMessage === "string") {
      return this.ntfMessage
        .replace(/<\/?(br)\s?\/?>/gim, ". ")
        .replace(/(<\/?[^>]*[^b]>)?/gim, "");
    }

    return "";
  };

  hide = () => {
    this.isVisible = false;
  };

  close = () => {
    this.isVisible = false;
  };

  disableNtf = () => {
    this.isDisplay = false;
  };

  openNtf = () => {
    if (this.ntfAction) {
      this.openNotificationUrl();
      this.rootStore.feeds.closeNotification(this.id, this.deliveryId, false);
    } else {
      this.openNotificationPreview();
      this.rootStore.feeds.closeNotification(this.id, null, true);
    }
  };

  openNotificationUrl = () => {
    window.open(this.ntfAction);
  };

  openNotificationPreview = () => {
    this.rootStore.notifications.handleWebPushNotifications(this.id);
  };

  openChat = () => {
    const { feeds } = this.rootStore;

    const url = this.messageLink;
    window.open(url, "chatTab");

    if (!feeds.showChatMessagesText) {
      feeds.closeGroupOfChatMessages(this.id);
    } else {
      feeds.closeNotification(this.id, null, true);
    }
  };

  addGroupedChatMessage = (id) => {
    this.groupedMessages.add(id);
  };

  get groupedChatMessagesCounter() {
    return this.groupedMessages.size + 1;
  }

  compareChatMessageSender = (chatNotification) =>
    this.channelId === chatNotification.channelId;
}

export default FeedNotification;
